import { render } from "./TargetView.vue?vue&type=template&id=febce89e&ts=true"
import script from "./TargetView.vue?vue&type=script&lang=ts"
export * from "./TargetView.vue?vue&type=script&lang=ts"

import "./TargetView.vue?vue&type=style&index=0&id=febce89e&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__